<template>
    <div class="roomCreator-wrapper">
        <div class="popup">
            <AutoCompleteUserSearch
                inputName="Добавить пользователя"
                :vizKey="[
                    'name',
                    'surname',
                    'patronymic',
                ]"
                :selectorValues="autoCompleteUsers"
                @autocomplete-item-click=
                    "addUserToPrepairArr($event)"
                @debounce-end="getAutoCompleteUsers"
            ></AutoCompleteUserSearch>
            <!-- <AutoCompleteUserSearch
                inputName="Добавить пользователя"
                :vizKey="[
                    'name',
                    'surname',
                ]"
                :selectorValues="autoCompleteUsers"
                @autocomplete-item-click=
                    "addUserToPrepairArr($event)"
                @debounce-end="getAutoCompleteUsers"
            ></AutoCompleteUserSearch> -->
            <div class="users">
                <div
                    class="chip"
                    v-for="(user, uindex) in sendArr"
                    :key="uindex"
                >
                    <div class="fio">
                        {{user.name}}
                        {{user.surname}}
                        <!-- {{user.user_patronymic}} -->
                    </div>
                    <div class="delete">
                        <font-awesome-icon
                            class="icon"
                            icon="times"
                            @click="deleteUser(uindex)"
                        ></font-awesome-icon>
                    </div>
                </div>
            </div>
            <div class="flex"></div>
            <div class="btns">
                <div
                    class="btn_default"
                    @click="createRoom"
                >Создать</div>
                <div
                    class="btn_default grey"
                    @click="$emit('close-room-creator')"
                >Отмена</div>
            </div>

        </div>
    </div>
</template>

<script>
import AutoCompleteUserSearch from '../inputs/AutoCompleteUserSearch';
import {get, post} from '../../../tools/http';
import {send} from '../../../tools/ws_chat';

export default {
    name: 'RoomCreator',
    data: ()=>({
        autoCompleteUsers: [],
        sendArr: [],
    }),
    components: {
        AutoCompleteUserSearch,
    },
    methods: {
        async getAutoCompleteUsers(event) {
            const data = {
                fields: ['id', 'userId', 'name', 'surname', 'patronymic'],
                filters: [{name: "search", value: event.value}],
            };
            const result = await post('profile', `users/search?limit=10&offset=0`, data, true);

            this.autoCompleteUsers = result.users;
        },
        addUserToPrepairArr(e){
            this.sendArr.push(e.value);
        },
        deleteUser(uindex){
            this.sendArr.splice(uindex, 1);
        },
        createRoom(){
            const usersToRoom = this.sendArr.map(itm=>itm.id);
            send('create_room', {users_to_group: usersToRoom});
            this.$emit('close-room-creator');
        },
    },
};
</script>

<style lang="scss" scoped>
    @import '../../../styles/rem';
    /*activate checkbox regExp in finder of phpStorm*/
    /*find      {: ([0-9]*)px}*/
    /*replace   {: rem($1);}*/
    .roomCreator-wrapper{
        position: absolute;
        top:0;
        left:0;
        width: 100%;
        height: 100%;
        background: rgba(130, 130, 130, 0.5);
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        .popup{
            padding: 1rem;
            width: 20rem;
            height: 20rem;
            background: white;
            border-radius: 0.2rem;
            display: flex;
            flex-direction: column;

            .users{
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                .chip{
                    margin: 0.3rem;
                    background: #5C9CEE;
                    font-size: 0.7rem;
                    padding: 0.2rem;
                    display: flex;
                    flex-direction: row;
                    border-radius: 0.2rem;
                    .fio{

                    }
                    .delete{
                        margin-left: 0.2rem;
                        cursor: pointer;
                    }
                }
            }

            .flex{
                flex: 1;
            }
            .btns{
                display: flex;
                flex-direction: row;
                justify-content: space-between;

                .btn_default {
                    display: block;
                    cursor: pointer;
                    font-size: rem(14);
                    line-height: rem(15);
                    padding: rem(12);
                    background-color: #4663AB;
                    border-radius: rem(4);
                    text-align: center;
                    font-weight: normal;
                    color: white;
                    width: 45%;
                }
                .grey{
                    background: grey;
                }
            }
        }
    }

    @import "../../../styles/variables";
    @media (max-width: $vm) {
        .roomCreator-wrapper{
            position: fixed;

            .popup{
                padding: mrem(12);
                width: 90%;
                height: mrem(450);
                background: white;
                border-radius: 0.2rem;
                display: flex;
                flex-direction: column;

                .input-name {
                    font-size: mrem(14);
                }

                .users{
                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;
                    .chip{
                        margin: 0.3rem;
                        background: #5C9CEE;
                        font-size: mrem(12);
                        padding: 0.2rem;
                        display: flex;
                        flex-direction: row;
                        border-radius: 0.2rem;
                        .fio{

                        }
                        .delete{
                            margin-left: 0.2rem;
                            cursor: pointer;
                        }
                    }
                }

                .flex{
                    flex: 1;
                }
                .btns{
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;

                    .btn_default {
                        display: block;
                        cursor: pointer;
                        font-size: mrem(14);
                        line-height: mrem(15);
                        padding: mrem(12);
                        background-color: #4663AB;
                        border-radius: mrem(4);
                        text-align: center;
                        font-weight: normal;
                        color: white;
                        width: 45%;
                    }
                    .grey{
                        background: grey;
                    }
                }
            }
        }
    }

</style>